export default "__VITE_ASSET__CqoDb0yf__"